// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Kontent$PrezzeeRibbon from "../../personal/Kontent/Kontent.bs.js";
import * as Footer__Responsive$PrezzeeRibbon from "./Footer__Responsive.bs.js";

function column(colWidth) {
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.media(Footer__Responsive$PrezzeeRibbon.tabletOrDesktop, [BsCssJs$PrezzeeRibbon.unsafe("gridColumn", "span " + String(colWidth))]),
              BsCssJs$PrezzeeRibbon.media(Footer__Responsive$PrezzeeRibbon.mobile, [BsCssJs$PrezzeeRibbon.gridColumnStart(1)])
            ]);
}

var Styles = {
  column: column
};

function Footer__Column(props) {
  var className = props.className;
  var colWidth = props.colWidth;
  var colWidth$1 = colWidth !== undefined ? colWidth : 1;
  var className$1 = className !== undefined ? className : "";
  var col = BsCssJs$PrezzeeRibbon.merge([
        column(colWidth$1),
        className$1
      ]);
  return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
              children: JsxRuntime.jsx("div", {
                    children: props.children,
                    className: col
                  })
            });
}

var make = Footer__Column;

export {
  Styles ,
  make ,
}
/* react/jsx-runtime Not a pure module */
